/// <reference path="../../node_modules/@types/jquery/index.d.ts" />

import { EligibilityFieldBinder } from '../common/EligibilityFieldBinder';
export class EligibilityVerificationVerify {
    public static Init() {
        EligibilityFieldBinder.Init();
    }
}

((window: any, document: any) => {
    $(() => {
        EligibilityVerificationVerify.Init();
    });
})(window, document);